import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { showTileView, hideTileView } from '../tileView/tileViewSlice';

const useTileView = () => {
  const dispatch = useDispatch();

  const value = useMemo(
    () => ({
      setTileView: ({ tileId, currentTab }) =>
        dispatch(showTileView({ tileId, currentTab })),
      hideTileView: () => dispatch(hideTileView()),
    }),
    [dispatch],
  );

  return value;
};

export { useTileView };
